// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function UmbrellaBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M30.491 15.787A14.554 14.554 0 0 0 6.125 6.351 14.431 14.431 0 0 0 1.5 15.787 2.5 2.5 0 0 0 4 18.5h10.5V25a4.5 4.5 0 1 0 9 0 1.5 1.5 0 1 0-3 0 1.5 1.5 0 1 1-3 0v-6.5H28a2.5 2.5 0 0 0 2.5-2.713h-.009Zm-17.94-.287c.334-4.916 2.26-7.939 3.449-9.359 1.19 1.424 3.115 4.445 3.449 9.359H12.55ZM8.164 8.558a11.5 11.5 0 0 1 4.211-2.477C11.1 8.156 9.799 11.26 9.545 15.5h-4.99a11.445 11.445 0 0 1 3.609-6.942ZM22.455 15.5c-.25-4.24-1.555-7.344-2.831-9.419a11.524 11.524 0 0 1 7.821 9.419h-4.99Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
